import StatusItemWrapper from "./StatusItemWrapper";

export default StatusItemWrapper;
